import { addHours, format, parseISO } from 'date-fns';
import { ko } from 'date-fns/esm/locale';

export const defaultDateFormat = `yyyy-MM-dd`; // 기본 날짜 데이터 송/수신 양식
// export const dashBoardDateFormat = `yyyy. MM. dd (ccc)`; // 대시보드내 날짜 선택 출력 양식
export const shortKoreanDateFormat = `yyyy년 MM월 dd일`; // 정기/일회성 업무 날짜 선택 출력 양식
export const longKoreanDateFormat = `yyyy년 MM월 dd일 (ccc)`; // 그 외 도메인 날짜 출력 방식

const defaultConfig = {
  locale: ko,
  weekdays: [
    '일요일',
    '월요일',
    '화요일',
    '수요일',
    '목요일',
    '금요일',
    '토요일',
  ],
  weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
};

function toKoreanDate(
  value: Date | string,
  dateFormat: string = defaultDateFormat
) {
  return format(
    addHours(parseISO(value instanceof Date ? value.toISOString() : value), 9),
    dateFormat,
    defaultConfig
  );
}

export default toKoreanDate;
